<template>
  <div>
    <v-card dark>
      <v-card-title>
        <h2>Notifications</h2>
        <v-spacer></v-spacer>
        <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table :pagination.sync="pagination" :loading="loading" light :search="search" :headers="headers"
        :items="notifications" class="elevation-1">
        <template slot="items" slot-scope="props">
          <!-- <td>{{ props.item.id }}</td> -->
          <td>{{ props.item.title }}</td>
          <td>{{ props.item.message }}</td>
          <td>{{ props.item.created | convertDate }}</td>
          <td>
            <v-icon color="primary" @click="editNotification(props.item)">edit</v-icon>
            <v-icon color="error" @click="deleteNotification(props.item)">delete</v-icon>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>

    <v-btn color="primary" @click.stop="createNotificationDialog = true" style="margin-left:0px;">Create Notification
    </v-btn>

    <v-dialog v-model="createNotificationDialog" max-width="700px">
      <v-card>
        <v-card-title>
          <h3>Create Notification</h3>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-layout column>
              <v-flex>
                <v-text-field v-model="title" label="Title" id="title" required></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="message" label="Message" id="message" required></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat v-on:click="closeCreateDialog">Close</v-btn>
          <v-btn color="success" v-on:click="createNotification" :disabled="!isComplete">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";
  import Notification from "../../../store/models/Notification.js";

  export default {
    data() {
      return {
        headers: [{
            text: "Title",
            align: "left",
            value: "title"
          },
          {
            text: "Message",
            align: "left",
            value: "message"
          },
          {
            text: "Created",
            align: "left",
            value: "created"
          },
          {
            text: "Actions",
            align: "left",
            value: "id"
          }
        ],
        search: "",
        pagination: {
          sortBy: "created",
          descending: "true"
        },
        createNotificationDialog: false,
        title: "",
        message: ""
      };
    },
    filters: {
      convertDate: function (t) {
        return new Date(t).toLocaleDateString();
      }
    },
    computed: {
      ...mapGetters({
        loading: "getLoading",
        notifications: "getNotifications"
      }),
      isComplete() {
        return this.title && this.message;
      }
    },
    methods: {
      createNotification() {
        let notification = new Notification(
          0,
          this.title,
          this.message,
          new Date().toISOString()
        );

        this.$store.dispatch("createNotification", notification);

        this.closeCreateDialog();
      },
      editNotification(notification) {
        this.$store.commit("setNotificationToEdit", notification);
        this.$router.push({
          path: "Notifications/Edit"
        });
      },
      deleteNotification(notification) {
        this.$confirm("Do you really want to delete this notification?").then(res => {
          if (res) {
            this.$store.dispatch("deleteNotification", notification);
          }
        });
      },
      closeCreateDialog() {
        this.title = "";
        this.message = "";
        this.createNotificationDialog = false;
      }
    },
    created: function () {
      this.$store.dispatch("getAllNotifications");
    }
  };
</script>